/* tslint:disable */
/* eslint-disable */
/**
 * SmartAI WL
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface KnowledgeBaseReadChatbot
 */
export interface KnowledgeBaseReadChatbot {
    /**
     * 
     * @type {string}
     * @memberof KnowledgeBaseReadChatbot
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof KnowledgeBaseReadChatbot
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof KnowledgeBaseReadChatbot
     */
    tooltip?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof KnowledgeBaseReadChatbot
     */
    isSpoKnowledgeBase: boolean;
}

/**
 * Check if a given object implements the KnowledgeBaseReadChatbot interface.
 */
export function instanceOfKnowledgeBaseReadChatbot(value: object): value is KnowledgeBaseReadChatbot {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('isSpoKnowledgeBase' in value) || value['isSpoKnowledgeBase'] === undefined) return false;
    return true;
}

export function KnowledgeBaseReadChatbotFromJSON(json: any): KnowledgeBaseReadChatbot {
    return KnowledgeBaseReadChatbotFromJSONTyped(json, false);
}

export function KnowledgeBaseReadChatbotFromJSONTyped(json: any, ignoreDiscriminator: boolean): KnowledgeBaseReadChatbot {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'tooltip': json['tooltip'] == null ? undefined : json['tooltip'],
        'isSpoKnowledgeBase': json['isSpoKnowledgeBase'],
    };
}

export function KnowledgeBaseReadChatbotToJSON(json: any): KnowledgeBaseReadChatbot {
    return KnowledgeBaseReadChatbotToJSONTyped(json, false);
}

export function KnowledgeBaseReadChatbotToJSONTyped(value?: KnowledgeBaseReadChatbot | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'tooltip': value['tooltip'],
        'isSpoKnowledgeBase': value['isSpoKnowledgeBase'],
    };
}

